import { CheckCircle, Laugh, Users, Brain, Building2, MessageSquare, Star } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

const benefits = [
  { title: "Integracja zespołu", description: "Wspólny śmiech zbliża ludzi i buduje silniejsze relacje w zespole", icon: Users },
  { title: "Redukcja stresu", description: "Humor to najlepszy sposób na rozładowanie napięcia w pracy", icon: Brain },
  { title: "Pozytywny wizerunek", description: "Pokazujesz, że Twoja firma dba o dobrą atmosferę i zadowolenie pracowników", icon: Building2 },
  { title: "Wzrost produktywności", description: "Zrelaksowani pracownicy są bardziej efektywni i kreatywni", icon: Star },
  { title: "Lepsza komunikacja", description: "Humor pomaga przełamać bariery i ułatwia komunikację w zespole", icon: MessageSquare },
  { title: "Niezapomniane wspomnienia", description: "Tworzymy momenty, które na długo pozostaną w pamięci pracowników", icon: Laugh },
];

export const Benefits = () => {
  return (
    <section id="benefits" className="py-24 bg-secondary">
      <div className="container">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="text-accent-warm font-semibold text-sm uppercase tracking-widest">Korzyści</span>
            <h2 className="text-4xl md:text-5xl font-montserrat font-black mt-3 text-foreground">
              Dlaczego warto?
            </h2>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return (
              <ScrollReveal key={benefit.title} delay={i * 100}>
                <div className="group p-8 rounded-2xl bg-background border border-border/50 card-hover hover:border-accent-warm/30">
                  <div className="w-14 h-14 rounded-xl bg-accent-warm/10 flex items-center justify-center mb-5 group-hover:bg-accent-warm/20 transition-colors">
                    <Icon className="w-7 h-7 text-accent-warm" />
                  </div>
                  <h3 className="text-xl font-montserrat font-bold mb-2 text-foreground">{benefit.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{benefit.description}</p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
